import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { ApiMobileConfigConstants } from "../../../shared/constants/api-constants/api-mobileConfig.constants";
import { HttpClient } from "@angular/common/http";
let MobileConfigSettingsService = class MobileConfigSettingsService {
    http;
    mobileConfigUrl = ApiMobileConfigConstants.URL;
    constructor(http) {
        this.http = http;
    }
    getMobileConfigDetails(mobileConfigId) {
        return this.http.get(`${this.mobileConfigUrl}/${mobileConfigId}`);
    }
    getMobileConfigs() {
        return this.http.get(this.mobileConfigUrl);
    }
    updateMobileConfig(mobileConfigId, mobileConfigData) {
        return this.http.patch(`${this.mobileConfigUrl}/${mobileConfigId}`, mobileConfigData);
    }
    static ctorParameters = () => [
        { type: HttpClient }
    ];
};
MobileConfigSettingsService = __decorate([
    Injectable({
        providedIn: "root"
    })
], MobileConfigSettingsService);
export { MobileConfigSettingsService };
